import { ButtonDialog } from '@autopass-web/mochi-component';

interface PaymentTicketAuthExpiredDialogProps {
  isOpen: boolean;
  onButtonClick: () => void;
}

export const PaymentTicketAuthExpiredDialog = ({
  isOpen,
  onButtonClick,
}: PaymentTicketAuthExpiredDialogProps) => (
  <ButtonDialog
    show={isOpen}
    title="付款逾時"
    message="付款時間已超過，請點擊「重新整理」按鈕後，再次確認付款資訊。"
    buttonList={[
      {
        theme: 'positive',
        content: '重新整理',
        onClick: onButtonClick,
        beLoading: false,
      },
    ]}
  />
);
